/**
 * Browsing data properties
 */
export class BrowsingData {
    public timestamp: string;
    public event: string;
    public params: any[];
}
